import React, { useState } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 300) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  window.addEventListener("scroll", handleScroll);

  return (
    <button
      onClick={handleClick}
      className={`fixed right-4 bottom-4 p-2 rounded-full transition-colors ${
        showButton ? "bg-secondary hover:bg-gray-600" : "bg-gray-300"
      }`}
    >
      <FaArrowUp className="text-white" />
    </button>
  );
};

export default ScrollToTopButton;
